const apiUrl = 'https://dev-api.gitcharger.com'; // https://dev-api.gitcharger.com/{service}/{version}/{the path that existed on original service}

export const environment = {
  production: false,
  apiUrl: 'https://station-service-r27bib7kla-uc.a.run.app',
  googleMapsApiKey: 'AIzaSyAl1zq-SILKDIE6At73pgf7R-vOofLc0L0',
  firebase: {
    apiKey: 'AIzaSyAl1zq-SILKDIE6At73pgf7R-vOofLc0L0',
    authDomain: 'gitcharger-dev.firebaseapp.com',
    projectId: 'gitcharger-dev',
    storageBucket: 'gitcharger-dev.appspot.com',
    messagingSenderId: '44284727423',
    appId: '1:44284727423:web:1405dbc542396494d3af4a',
    measurementId: 'G-9BNEMHF97W',
    // Browser push VAPID key — get from Firebase Console → Project Settings →
    // Cloud Messaging → Web configuration → "Generate key pair". Leave empty
    // to disable browser push (follow still works, just no notifications).
    vapidKey: 'BKYkm990pRZoo3AdE7cvrP_VY5URf0iJPKB2-cop-yzkQ5iaYbFYOUNUNvCFLN8Yz3N4KypPV03Ba2Vc_sM25eY',
  },

  api: {
    stations_gql: apiUrl + '/station/v1/graphql',
    user: apiUrl + '/user/v1/v1',
    file: apiUrl + '/file/v1',
    station: apiUrl + '/station/v1',
    feedback: apiUrl + '/feedback/v1/api/v1',
    rewards: apiUrl + '/reward/v1/api',
    search: apiUrl + '/search/v1',
    gateway: apiUrl + '/gateway/v1',
    chat: apiUrl + '/chat/v1',
    repair: apiUrl + '/feedback/v1/api/v1', // repair-dispatch endpoints are hosted in feedback-service
  },

  advertiseUrl: 'https://dev-ads.gitcharger.com',

  supabase: {
    url: 'https://pazofipvcfzqzctpuoyu.supabase.co',
    anonKey: 'sb_publishable_rfObOSsbecCMZ5cXdH4-8A_jFnl-V5e',
  },

  stripe: {
    publishableKey: 'pk_test_51QJlaFIjdJ8yolDDBd9cWR3QHMmNjhuENF7lKCKIAsdpctoNaVcAAuZQV9M6noJDmWQsI0kmTE4y7vxSchv4C9F500aNCxZvMv',
    secretKey: 'sk_test_51QJlaFIjdJ8yolDDxrg7Xb4U2uTfexxGXfjArKi7xkNnKUT0Swxt44nQgoEBkne3kc6d9wZSHzXviETi6rLqrWpc00bMpuQhvP',
  },

  ads: {
    apiUrl: apiUrl + '/a-brand/v1',
    enabled: true,
    useMockAds: false,
    placements: {
      mapView: false,
      mapPin: true,
      stationDetailsImage: true,
      stationDetailsActions: true,
      stationDetailsBottom: true,
      searchResults: true,
      navigationRoute: true,
      navigationBottom: true,
    },
  },

  recaptcha: {
    siteKey: '6LdC_PkqAAAAAI6wlFDwZRzlCUr0tV-pq9DGfkrI',
  },

  devcycleClientSdkKey: 'dvc_client_08524316_c8ad_4df9_95da_c48af39c7c19_7d97a74',
  tourStation: {
    stationId: 5321,
    latitude: 53.916342,
    longitude: -1.277242,
  },
};
